import { render, staticRenderFns } from "./generic-modal.vue?vue&type=template&id=b7bc943c&scoped=true&"
import script from "./generic-modal.vue?vue&type=script&lang=tsx&"
export * from "./generic-modal.vue?vue&type=script&lang=tsx&"
import style0 from "./generic-modal.vue?vue&type=style&index=0&id=b7bc943c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bc943c",
  null
  
)

export default component.exports